import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const BlackboardWriterForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="blackboardWriterFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={form.formState.errors.name?.message}
      />
      <FormField
        controlId="blackboardWriterFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={form.formState.errors.type?.message}
      />
      <FormField
        controlId="blackboardWriterFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="blackboardWriterFormOnError"
        label="onError"
        name="onError"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors?.onError?.message}
      >
        <option value="">Select On Error</option>
        <option value="continue">Continue</option>
        <option value="stop">Stop</option>
      </FormField>
      <FormField
        controlId="blackboardWriterFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="blackboardWriterFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.format?.message}
      />
      <FormField
        controlId="blackboardWriterFormKey"
        label="key"
        name="properties.key"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter key"
        error={errors?.properties?.key?.message}
      />
      <FormField
        controlId="blackboardWriterFormSecret"
        label="secret"
        name="properties.secret"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter secret"
        error={errors?.properties?.secret?.message}
      />
      <FormField
        controlId="blackboardWriterFormPath"
        label="path"
        name="properties.path"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter path"
        required
        error={form.formState.errors.properties?.path?.message}
      />
      <FormField
        controlId="blackboardWriterFormHttpMethod"
        label="httpMethod"
        name="properties.httpMethod"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        placeholder="Select HTTP method"
        required
        error={errors?.properties?.httpMethod?.message}
      >
        <option value="">Select HTTP Method</option>
        <option value="GET">GET</option>
        <option value="POST">POST</option>
        <option value="PUT">PUT</option>
        <option value="DELETE">DELETE</option>
      </FormField>
      <FormField
        controlId="blackboardWriterFormHeaders"
        label="headers"
        name="properties.headers"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXTAREA}
        placeholder="Enter headers"
        error={errors?.properties?.headers?.message}
      />
      <FormField
        controlId="blackboardWriterFormHeadersJson"
        label="headersJson"
        name="properties.headersJson"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.JSON}
        placeholder="Enter headers JSON"
        error={errors?.properties?.headersJson?.message}
      />
      <FormField
        controlId="blackboardWriterFormInputTemplateRef"
        label="inputTemplateRef"
        name="properties.inputTemplateRef"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter input template ref"
        error={errors?.properties?.inputTemplateRef?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default BlackboardWriterForm;
